// Profinoks translation utility
// Generated for complete bilingual coverage across all products and categories

export const mappings = [
    { tr: /\bdikdörtgen\b/gi, en: "Rectangular" },
    { tr: /\bısıtıcılar\b/gi, en: "Heaters" },
    { tr: /\bçekmecesiz\b/gi, en: "without Drawers" },
    { tr: /\bçekmeceler\b/gi, en: "Drawers" },
    { tr: /\bsoğutmalı\b/gi, en: "Refrigerated" },
    { tr: /\bçekmeceli\b/gi, en: "with Drawers" },
    { tr: /\bçekmecesi\b/gi, en: "Drawer" },
    { tr: /\btenceresi\b/gi, en: "Pot" },
    { tr: /\byuvarlak\b/gi, en: "Round" },
    { tr: /\bsoğutucu\b/gi, en: "Cooler" },
    { tr: /\bısıtmalı\b/gi, en: "Heated" },
    { tr: /\barabalar\b/gi, en: "Trolleys" },
    { tr: /\bkapıları\b/gi, en: "Doors" },
    { tr: /\bkapaklar\b/gi, en: "Lids" },
    { tr: /\bkapaksız\b/gi, en: "without Lid" },
    { tr: /\bçerezlik\b/gi, en: "Snack Dish" },
    { tr: /\bkaydırma\b/gi, en: "Sliding" },
    { tr: /\bçikolata\b/gi, en: "Chocolate" },
    { tr: /\bekonomik\b/gi, en: "Economy" },
    { tr: /\bsoğutma\b/gi, en: "Cooling" },
    { tr: /\bısıtıcı\b/gi, en: "Heater" },
    { tr: /\barabası\b/gi, en: "Trolley" },
    { tr: /\bçekmece\b/gi, en: "Drawer" },
    { tr: /\brafları\b/gi, en: "Shelves" },
    { tr: /\bkapısız\b/gi, en: "without Doors" },
    { tr: /\bkapaklı\b/gi, en: "with Lid" },
    { tr: /\bpişirme\b/gi, en: "Cooking / Baking" },
    { tr: /\bkapları\b/gi, en: "Containers" },
    { tr: /\bi̇çecek\b/gi, en: "Beverage" },
    { tr: /\bpatates\b/gi, en: "Potato" },
    { tr: /\bfırınlı\b/gi, en: "with Oven" },
    { tr: /\bfincanı\b/gi, en: "Cup" },
    { tr: /\bbardağı\b/gi, en: "Glass" },
    { tr: /\btencere\b/gi, en: "Pot" },
    { tr: /\btepsisi\b/gi, en: "Tray" },
    { tr: /\bısıtma\b/gi, en: "Heating" },
    { tr: /\btakımı\b/gi, en: "Set" },
    { tr: /\brafsız\b/gi, en: "without Shelf" },
    { tr: /\bkapılı\b/gi, en: "with Doors" },
    { tr: /\bkapısı\b/gi, en: "Door" },
    { tr: /\bkapağı\b/gi, en: "Lid" },
    { tr: /\bdörtlü\b/gi, en: "4-Tier / Quad" },
    { tr: /\baltılı\b/gi, en: "6-Burner / Six-Tier" },
    { tr: /\barkası\b/gi, en: "Back" },
    { tr: /\bortası\b/gi, en: "Middle" },
    { tr: /\byapımı\b/gi, en: "Making" },
    { tr: /\biçecek\b/gi, en: "Beverage" },
    { tr: /\bızgara\b/gi, en: "Grill / Griddle" },
    { tr: /\bkuzine\b/gi, en: "Range Cooker" },
    { tr: /\bfritöz\b/gi, en: "Deep Fryer" },
    { tr: /\btabağı\b/gi, en: "Plate" },
    { tr: /\bkasesi\b/gi, en: "Bowl" },
    { tr: /\bfincan\b/gi, en: "Cup" },
    { tr: /\bbardak\b/gi, en: "Glass" },
    { tr: /\bkaşığı\b/gi, en: "Spoon" },
    { tr: /\bçatalı\b/gi, en: "Fork" },
    { tr: /\bbıçağı\b/gi, en: "Knife" },
    { tr: /\btavası\b/gi, en: "Pan" },
    { tr: /\bkayık\b/gi, en: "Oval / Boat" },
    { tr: /\büçgen\b/gi, en: "Triangular" },
    { tr: /\bsoğuk\b/gi, en: "Cold" },
    { tr: /\bsıcak\b/gi, en: "Hot" },
    { tr: /\bkatlı\b/gi, en: "Tier" },
    { tr: /\btakım\b/gi, en: "Set" },
    { tr: /\baraba\b/gi, en: "Trolley" },
    { tr: /\braflı\b/gi, en: "with Shelf" },
    { tr: /\bkapak\b/gi, en: "Lid" },
    { tr: /\bbeşli\b/gi, en: "5-Tier" },
    { tr: /\bdöner\b/gi, en: "Doner / Rotary" },
    { tr: /\bdünya\b/gi, en: "World" },
    { tr: /\bbalık\b/gi, en: "Fish" },
    { tr: /\btavuk\b/gi, en: "Poultry" },
    { tr: /\bkemik\b/gi, en: "Bone" },
    { tr: /\bsebze\b/gi, en: "Vegetable" },
    { tr: /\bmeyve\b/gi, en: "Fruit" },
    { tr: /\bsoğan\b/gi, en: "Onion" },
    { tr: /\bekmek\b/gi, en: "Bread" },
    { tr: /\bhamur\b/gi, en: "Dough" },
    { tr: /\bpasta\b/gi, en: "Pastry / Cake" },
    { tr: /\bbörek\b/gi, en: "Bakery" },
    { tr: /\btatlı\b/gi, en: "Dessert" },
    { tr: /\bkahve\b/gi, en: "Coffee" },
    { tr: /\bbiber\b/gi, en: "Pepper" },
    { tr: /\bşeker\b/gi, en: "Sugar" },
    { tr: /\bkürek\b/gi, en: "Peel / Shovel" },
    { tr: /\bfırın\b/gi, en: "Oven" },
    { tr: /\btabak\b/gi, en: "Plate" },
    { tr: /\bkaşık\b/gi, en: "Spoon" },
    { tr: /\bçatal\b/gi, en: "Fork" },
    { tr: /\bbıçak\b/gi, en: "Knife" },
    { tr: /\btepsi\b/gi, en: "Tray" },
    { tr: /\bkare\b/gi, en: "Square" },
    { tr: /\boval\b/gi, en: "Oval" },
    { tr: /\brafı\b/gi, en: "Shelf" },
    { tr: /\bkapı\b/gi, en: "Door" },
    { tr: /\bçift\b/gi, en: "Double" },
    { tr: /\büçlü\b/gi, en: "3-Tier / Triple" },
    { tr: /\barka\b/gi, en: "Back" },
    { tr: /\byanı\b/gi, en: "Side" },
    { tr: /\borta\b/gi, en: "Middle / Island" },
    { tr: /\büstü\b/gi, en: "Top / Countertop" },
    { tr: /\baltı\b/gi, en: "Bottom / Base" },
    { tr: /\bkabı\b/gi, en: "Container" },
    { tr: /\bocak\b/gi, en: "Cooktop / Stove" },
    { tr: /\bkase\b/gi, en: "Bowl" },
    { tr: /\btava\b/gi, en: "Pan" },
    { tr: /\blüks\b/gi, en: "Luxury" },
    { tr: /\bkat\b/gi, en: "Tier" },
    { tr: /\braf\b/gi, en: "Shelf" },
    { tr: /\btek\b/gi, en: "Single" },
    { tr: /\bönü\b/gi, en: "Front" },
    { tr: /\byan\b/gi, en: "Side" },
    { tr: /\büst\b/gi, en: "Top" },
    { tr: /\balt\b/gi, en: "Bottom" },
    { tr: /\btaş\b/gi, en: "Stone" },
    { tr: /\bkap\b/gi, en: "Container" },
    { tr: /\bçay\b/gi, en: "Tea" },
    { tr: /\bsüt\b/gi, en: "Milk" },
    { tr: /\byağ\b/gi, en: "Oil" },
    { tr: /\btuz\b/gi, en: "Salt" },
    { tr: /\bbuz\b/gi, en: "Ice" },
    { tr: /\blüx\b/gi, en: "Luxury" },
    { tr: /\beko\b/gi, en: "Eco" },
    { tr: /\bön\b/gi, en: "Front" },
    { tr: /\bet\b/gi, en: "Meat" },
    { tr: /\bsu\b/gi, en: "Water" },
    { tr: /\bun\b/gi, en: "Flour" },
    { tr: /\bNormal Devirli Çamaşır Yıkama Sıkma Makinesi\b/gi, en: "Normal Speed Washer Extractor" },
    { tr: /\bYüksek Devirli Çamaşır Yıkama Sıkma Makinesi\b/gi, en: "High Speed Washer Extractor" },
    { tr: /\bGiyotin Tipi Bulaşık Yıkama Makinesi\b/gi, en: "Hood Type Dishwasher" },
    { tr: /\bPolietilen Çalışma Tezgahı Et Kütüğü\b/gi, en: "Polyethylene Worktable Chopping Block" },
    { tr: /\bGiyotin Tip Bulaşık Yıkama Makinesi\b/gi, en: "Hood Type Dishwasher" },
    { tr: /\bKonveyörlü Bulaşık Yıkama Makinesi\b/gi, en: "Conveyor Dishwasher" },
    { tr: /\bSebze Yıkama ve Kurutma Makineleri\b/gi, en: "Vegetable Washing & Drying Machines" },
    { tr: /\bPolietilen Tablalı Çalışma Tezgahı\b/gi, en: "Worktable with Polyethylene Top" },
    { tr: /\bBataryalı ve Su Sayaçlı Ara Tezgah\b/gi, en: "Intermediate Table with Mixer Tap & Water Meter" },
    { tr: /\bKepçe, Kevgir, Spatula ve Kaşıklar\b/gi, en: "Ladles, Skimmers, Spatulas & Spoons" },
    { tr: /\bSet Üstü Ekmek Dilimleme Makinesi\b/gi, en: "Countertop Bread Slicing Machine" },
    { tr: /\bTrabzon Ekmeği Dilimleme Makinesi\b/gi, en: "Trabzon Bread Slicing Machine" },
    { tr: /\bSet Altı Bardak Yıkama  Makinesi\b/gi, en: "Undercounter Glasswasher" },
    { tr: /\bSet Altı Bulaşık Yıkama Makinesi\b/gi, en: "Undercounter Dishwasher" },
    { tr: /\bTrabzon Ekmek Dilimleme Makinesi\b/gi, en: "Trabzon Bread Slicing Machine" },
    { tr: /\bSebze Yıkama ve Kurutma Makinesi\b/gi, en: "Vegetable Washing & Drying Machine" },
    { tr: /\bSıcak Tutucu Patates Dinlendirme\b/gi, en: "Chip Scuttle & Fry Warmer" },
    { tr: /\bSet Altı Bardak Yıkama Makinesi\b/gi, en: "Undercounter Glasswasher" },
    { tr: /\bSet Altı Bardak Yıkama Makinası\b/gi, en: "Undercounter Glasswasher" },
    { tr: /\bSimit ve Sandviç Kesme Makinesi\b/gi, en: "Bagel & Sandwich Cutting Machine" },
    { tr: /\bTezgah Tipi Çekmeceli Buzdolabı\b/gi, en: "Counter Refrigerator with Drawers" },
    { tr: /\bOtomatik Soft Dondurma Makinesi\b/gi, en: "Automatic Soft Serve Ice Cream Machine" },
    { tr: /\bBulaşık Makinası Giriş Tezgahı\b/gi, en: "Dishwasher Inlet Table" },
    { tr: /\bBulaşık Makinası Çıkış Tezgahı\b/gi, en: "Dishwasher Outlet Table" },
    { tr: /\bBulaşık Makinesi Giriş Tezgahı\b/gi, en: "Dishwasher Inlet Table" },
    { tr: /\bBulaşık Makinesi Çıkış Tezgahı\b/gi, en: "Dishwasher Outlet Table" },
    { tr: /\bAdana Kebap Hazırlama Makinesi\b/gi, en: "Adana Kebab Preparation Machine" },
    { tr: /\bSimit & Sandviç Kesme Makinesi\b/gi, en: "Bagel & Sandwich Cutting Machine" },
    { tr: /\bÇatallı Hamur Yoğurma Makinesi\b/gi, en: "Fork Dough Kneader" },
    { tr: /\bKöfte Şekillendirme Makineleri\b/gi, en: "Meatball Forming Machines" },
    { tr: /\bSebze ve Meyve Yıkama Makinesi\b/gi, en: "Vegetable & Fruit Washing Machine" },
    { tr: /\bMermer Tablalı Çalışma Tezgahı\b/gi, en: "Worktable with Marble Top" },
    { tr: /\bGranit Tablalı Çalışma Tezgahı\b/gi, en: "Worktable with Granite Top" },
    { tr: /\bÇalışma Tezgahı Blok Çekmeceli\b/gi, en: "Worktable with Drawer Block" },
    { tr: /\bAçacak ve Kabuk Şekillendirici\b/gi, en: "Opener & Peeler / Zester" },
    { tr: /\bGiyotin Tipi Bulaşık Makinesi\b/gi, en: "Hood Type Dishwasher" },
    { tr: /\bSpiral Hamur Yoğurma Makinesi\b/gi, en: "Spiral Dough Kneader" },
    { tr: /\bSebze-Et Parçalama Makineleri\b/gi, en: "Vegetable & Meat Cutter Mixers" },
    { tr: /\bBulama ve Paneleme Makineleri\b/gi, en: "Breading & Battering Machines" },
    { tr: /\bIsıtmalı Tabak Otomat Arabası\b/gi, en: "Heated Plate Dispenser Trolley" },
    { tr: /\bTabak Otomat Arabası Isıtmalı\b/gi, en: "Heated Plate Dispenser Trolley" },
    { tr: /\bÇamaşır Yıkama Sıkma Makinesi\b/gi, en: "Washer Extractor" },
    { tr: /\bÇamaşır Yıkama Sıkma Makinası\b/gi, en: "Washer Extractor" },
    { tr: /\bÇatal, Bıçak ve Kaşık Setleri\b/gi, en: "Cutlery & Flatware Sets" },
    { tr: /\bParlatıcı ve Deterjan Pompalı\b/gi, en: "with Rinse Aid & Detergent Pump" },
    { tr: /\bGiyotin Tip Bulaşık Makinesi\b/gi, en: "Hood Type Dishwasher" },
    { tr: /\bKöfte Şekillendirme Makinesi\b/gi, en: "Meatball Forming Machine" },
    { tr: /\bBuzdolapları ve Dondurucular\b/gi, en: "Refrigerators & Freezers" },
    { tr: /\bBantlı Silindir Ütü Makinesi\b/gi, en: "Belt Cylinder Ironer Machine" },
    { tr: /\bBantlı Silindir Ütü Makinası\b/gi, en: "Belt Cylinder Ironer Machine" },
    { tr: /\bKetçap, Mayonez ve Sosluklar\b/gi, en: "Ketchup, Mayonnaise & Sauce Dispensers" },
    { tr: /\bKonveyörlü Bulaşık Makinesi\b/gi, en: "Conveyor Dishwasher" },
    { tr: /\bHamur Kesme Tartma Makinesi\b/gi, en: "Dough Divider & Weigher" },
    { tr: /\bSebze-Et Parçalama Makinesi\b/gi, en: "Vegetable & Meat Cutter Mixer" },
    { tr: /\bBulama ve Paneleme Makinesi\b/gi, en: "Breading & Battering Machine" },
    { tr: /\bBuzdolaplar ve Dondurucular\b/gi, en: "Refrigerators & Freezers" },
    { tr: /\bYarı Oluklu Yarı Düz Izgara\b/gi, en: "Half Ribbed Half Flat Griddle" },
    { tr: /\bDörtlü Blok Çekmeceli Ünite\b/gi, en: "4-Drawer Block Unit" },
    { tr: /\bTel Kevgir ve Tel Süzgeçler\b/gi, en: "Wire Skimmers & Wire Strainers" },
    { tr: /\bYardımcı Mutfak Ekipmanları\b/gi, en: "Auxiliary Kitchen Equipment" },
    { tr: /\bPatates Dilimleme Makinesi\b/gi, en: "Potato Slicing Machine" },
    { tr: /\bİkili Blok Çekmeceli Ünite\b/gi, en: "2-Drawer Block Unit" },
    { tr: /\bAçık Büfe Servis Üniteleri\b/gi, en: "Open Buffet Service Units" },
    { tr: /\bKöşeli ve Yeni Otel Serisi\b/gi, en: "Corner & New Hotel Series" },
    { tr: /\bKahvaltılık ve Çerezlikler\b/gi, en: "Breakfast & Snack Bowls" },
    { tr: /\bEspresso Fincanı ve Tabağı\b/gi, en: "Espresso Cup & Saucer" },
    { tr: /\bÇatal, Bıçak & Kaşık Grubu\b/gi, en: "Cutlery & Flatware Group" },
    { tr: /\bBambu Bıçak ve Bileyiciler\b/gi, en: "Bamboo Knives & Sharpeners" },
    { tr: /\bGastronorm Küvet Kapakları\b/gi, en: "Gastronorm Container Lids" },
    { tr: /\bSet Altı Bulaşık Makinesi\b/gi, en: "Undercounter Dishwasher" },
    { tr: /\bSet Altı Bulaşık Makinası\b/gi, en: "Undercounter Dishwasher" },
    { tr: /\bGıda Dilimleme Makineleri\b/gi, en: "Food Slicing Machines" },
    { tr: /\bPastacılık Krema Makinesi\b/gi, en: "Pastry Cream Cooker & Machine" },
    { tr: /\bHaznesiz Küp Buz Makinesi\b/gi, en: "Modular Cube Ice Machine without Bin" },
    { tr: /\bHareketli Çalışma Tezgahı\b/gi, en: "Mobile Worktable" },
    { tr: /\bÜçlü Blok Çekmeceli Ünite\b/gi, en: "3-Drawer Block Unit" },
    { tr: /\bTepsi ve Kaşıklık Ünitesi\b/gi, en: "Tray & Cutlery Dispenser Unit" },
    { tr: /\bBorulu Pişirme Fırınları\b/gi, en: "Tube Baking Ovens" },
    { tr: /\bEkmek Dilimleme Makinesi\b/gi, en: "Bread Slicing Machine" },
    { tr: /\bHamur Yoğurma Makineleri\b/gi, en: "Dough Kneading Machines" },
    { tr: /\bHamur Yuvarlama Makinesi\b/gi, en: "Dough Rounder" },
    { tr: /\bSebze Doğrama Makineleri\b/gi, en: "Vegetable Cutting Machines" },
    { tr: /\bPatates Soyma Makineleri\b/gi, en: "Potato Peeling Machines" },
    { tr: /\bVakum Paketleme Makinesi\b/gi, en: "Vacuum Packaging Machine" },
    { tr: /\bHamur Hazırlık Buzdolabı\b/gi, en: "Dough Prep Refrigerator" },
    { tr: /\bHazneli Küp Buz Makinesi\b/gi, en: "Cube Ice Machine with Bin" },
    { tr: /\bDevrilir Ekmeklik Modülü\b/gi, en: "Tilting Bread Bin Module" },
    { tr: /\bHijyen Paspası ve Tavası\b/gi, en: "Hygiene Mat & Tray" },
    { tr: /\bÇamaşır Kurutma Makinesi\b/gi, en: "Tumble Dryer" },
    { tr: /\bÇamaşır Kurutma Makinası\b/gi, en: "Tumble Dryer" },
    { tr: /\bKesme ve Steak Tahtaları\b/gi, en: "Cutting & Steak Boards" },
    { tr: /\bDelikli Gastronorm Küvet\b/gi, en: "Perforated Gastronorm Container" },
    { tr: /\bBulaşık Yıkama Makinesi\b/gi, en: "Dishwasher" },
    { tr: /\bBulaşık Yıkama Makinası\b/gi, en: "Dishwasher" },
    { tr: /\bBaget Ekmek Dilimleyici\b/gi, en: "Baguette Bread Slicer" },
    { tr: /\bEt ve Kemik Testereleri\b/gi, en: "Meat & Bone Saws" },
    { tr: /\bGıda Dilimleme Makinesi\b/gi, en: "Food Slicing Machine" },
    { tr: /\bSalata Hazırlık Tezgahı\b/gi, en: "Salad Prep Counter" },
    { tr: /\bDondurma Teşhir Vitrini\b/gi, en: "Ice Cream Display Showcase" },
    { tr: /\bDolaplı Çalışma Tezgahı\b/gi, en: "Cupboard Worktable" },
    { tr: /\bTemizlik Ekipman Dolabı\b/gi, en: "Cleaning Equipment Cabinet" },
    { tr: /\bBanket Arabası Isıtmalı\b/gi, en: "Heated Banquet Trolley" },
    { tr: /\bÇamaşırhane Ekipmanları\b/gi, en: "Laundry Equipment" },
    { tr: /\bPortakal Sıkma Makinesi\b/gi, en: "Orange Juicer Machine" },
    { tr: /\bDuvar Tipi Davlumbazlar\b/gi, en: "Wall Type Exhaust Hoods" },
    { tr: /\bKahve Fincanı ve Tabağı\b/gi, en: "Coffee Cup & Saucer" },
    { tr: /\bGastronorm Küvet Kapağı\b/gi, en: "Gastronorm Container Lid" },
    { tr: /\bTek Kullanımlık Ürünler\b/gi, en: "Disposable Products" },
    { tr: /\bÇok Kullanımlık Ürünler\b/gi, en: "Reusable Products" },
    { tr: /\bBardak Yıkama Makinesi\b/gi, en: "Glasswasher" },
    { tr: /\bBardak Yıkama Makinası\b/gi, en: "Glasswasher" },
    { tr: /\bProfesyonel El Mikseri\b/gi, en: "Professional Hand Mixer" },
    { tr: /\bHamur Yoğurma Makinesi\b/gi, en: "Dough Kneader" },
    { tr: /\bSebze Doğrama Makinesi\b/gi, en: "Vegetable Cutter" },
    { tr: /\bSebze Doğrama Makinası\b/gi, en: "Vegetable Cutter" },
    { tr: /\bPatates Soyma Makinesi\b/gi, en: "Potato Peeling Machine" },
    { tr: /\bSoğan Doğrama Makinesi\b/gi, en: "Onion Chopper" },
    { tr: /\bSoğan Doğrama Makinası\b/gi, en: "Onion Chopper" },
    { tr: /\bLokma Dökme Makineleri\b/gi, en: "Lokma Doughnut Machines" },
    { tr: /\bPizza Hazırlık Tezgahı\b/gi, en: "Pizza Prep Counter" },
    { tr: /\bSoft Dondurma Makinesi\b/gi, en: "Soft Serve Ice Cream Machine" },
    { tr: /\bSosis Haşlama Makinesi\b/gi, en: "Hot Dog Steamer" },
    { tr: /\bSosis Pişirme Makinesi\b/gi, en: "Roller Grill Hot Dog Cooker" },
    { tr: /\bDolaplı Çalışma Masası\b/gi, en: "Cupboard Worktable" },
    { tr: /\bDolaplı Çalışma Modülü\b/gi, en: "Cupboard Work Unit" },
    { tr: /\bÇalışma Tezgahı Sırtlı\b/gi, en: "Worktable with Upstand" },
    { tr: /\bTepsi Taşıma Arabaları\b/gi, en: "Tray Transport Trolleys" },
    { tr: /\bDavlumbaz Aydınlatması\b/gi, en: "Exhaust Hood Lighting" },
    { tr: /\bKonsome Kase ve Tabağı\b/gi, en: "Consomme Bowl & Saucer" },
    { tr: /\bKazan Yıkama Makinesi\b/gi, en: "Pot & Pan Washer" },
    { tr: /\bBorulu Pişirme Fırını\b/gi, en: "Tube Baking Oven" },
    { tr: /\bPasta Börek Fırınları\b/gi, en: "Pastry & Bakery Ovens" },
    { tr: /\bEt ve Kemik Testeresi\b/gi, en: "Meat & Bone Saw" },
    { tr: /\bHamur Açma Makineleri\b/gi, en: "Dough Sheeters" },
    { tr: /\bTezgah Tipi Buzdolabı\b/gi, en: "Counter Refrigerator" },
    { tr: /\bTezgah Tipi Dondurucu\b/gi, en: "Counter Freezer" },
    { tr: /\bTepsi Toplama Arabası\b/gi, en: "Tray Clearing Trolley" },
    { tr: /\bKirli Toplama Arabası\b/gi, en: "Clearing Dish Trolley" },
    { tr: /\bAçık Büfe Ekipmanları\b/gi, en: "Open Buffet Equipment" },
    { tr: /\bSilindir Ütü Makinesi\b/gi, en: "Cylinder Ironer Machine" },
    { tr: /\bSilindir Ütü Makinası\b/gi, en: "Cylinder Ironer Machine" },
    { tr: /\bFiltre Kahve Makinesi\b/gi, en: "Filter Coffee Machine" },
    { tr: /\bTürk Kahvesi Makinesi\b/gi, en: "Turkish Coffee Machine" },
    { tr: /\bBardak Fincan Isıtıcı\b/gi, en: "Cup & Glass Warmer" },
    { tr: /\bOrta Tip Davlumbazlar\b/gi, en: "Island Type Exhaust Hoods" },
    { tr: /\bÇay Fincanı ve Tabağı\b/gi, en: "Tea Cup & Saucer" },
    { tr: /\bKazan Yıkama Tezgahı\b/gi, en: "Pot Washing Table" },
    { tr: /\bAdana Kebap Makinesi\b/gi, en: "Adana Kebab Machine" },
    { tr: /\bLokma Dökme Makinesi\b/gi, en: "Lokma Doughnut Machine" },
    { tr: /\bPanel Tipi Soğuk Oda\b/gi, en: "Panel Type Cold Room" },
    { tr: /\bBar Arkası Buzdolabı\b/gi, en: "Back Bar Refrigerator" },
    { tr: /\bŞarap Soğutucu Dolap\b/gi, en: "Wine Cooler Cabinet" },
    { tr: /\bKaynatma Tencereleri\b/gi, en: "Boiling Pans" },
    { tr: /\bPaspas Yıkama Evyesi\b/gi, en: "Mop Sink" },
    { tr: /\bBlok Çekmeceli Ünite\b/gi, en: "Drawer Block Unit" },
    { tr: /\bIsıtıcılı Ara Tezgah\b/gi, en: "Heated Intermediate Table" },
    { tr: /\bTabak Otomat Arabası\b/gi, en: "Plate Dispenser Trolley" },
    { tr: /\bTepsi Taşıma Arabası\b/gi, en: "Tray Transport Trolley" },
    { tr: /\bEkmek Servis Ünitesi\b/gi, en: "Bread Service Unit" },
    { tr: /\bSıcak Servis Ünitesi\b/gi, en: "Hot Service Unit" },
    { tr: /\bSoğuk Servis Ünitesi\b/gi, en: "Cold Service Unit" },
    { tr: /\bDuvar Tipi Davlumbaz\b/gi, en: "Wall Type Exhaust Hood" },
    { tr: /\bTürk Kahvesi Fincanı\b/gi, en: "Turkish Coffee Cup" },
    { tr: /\bDemir Döküm Sunumlar\b/gi, en: "Cast Iron Presentation Ware" },
    { tr: /\bMasaüstü Ekipmanları\b/gi, en: "Tabletop Equipment" },
    { tr: /\bPolikarbonat Ürünler\b/gi, en: "Polycarbonate Products" },
    { tr: /\bKazan Kabul Tezgahı\b/gi, en: "Pot Reception Table" },
    { tr: /\bKonveyörlü Fırınlar\b/gi, en: "Conveyor Ovens" },
    { tr: /\bKonveksiyonlu Fırın\b/gi, en: "Convection Oven" },
    { tr: /\bDöner Arabalı Fırın\b/gi, en: "Rotary Rack Oven" },
    { tr: /\bMayalandırma Dolabı\b/gi, en: "Proofing Cabinet" },
    { tr: /\bMayalandırma Kabini\b/gi, en: "Proofing Cabinet" },
    { tr: /\bVitesli El Blenderi\b/gi, en: "Variable Speed Hand Blender" },
    { tr: /\bHamur Açma Makinesi\b/gi, en: "Dough Sheeter" },
    { tr: /\bZırh Kıyma Makinesi\b/gi, en: "Zırh Mincing Machine" },
    { tr: /\bPasta Teşhir Dolabı\b/gi, en: "Pastry Display Cabinet" },
    { tr: /\bPatates Dinlendirme\b/gi, en: "Chip Scuttle" },
    { tr: /\bMakarna Pişiriciler\b/gi, en: "Pasta Cookers" },
    { tr: /\bLavataşlı Izgaralar\b/gi, en: "Lava Rock Grills" },
    { tr: /\bPişirme Ekipmanları\b/gi, en: "Cooking Equipment" },
    { tr: /\bSebze Süzme Tezgahı\b/gi, en: "Vegetable Draining Table" },
    { tr: /\bÇöp Sıyırma Tezgahı\b/gi, en: "Waste Scraping Table" },
    { tr: /\bBıçak Steril Dolabı\b/gi, en: "Knife Sterilizer Cabinet" },
    { tr: /\bKöşe Ünitesi Sırtlı\b/gi, en: "Corner Unit with Upstand" },
    { tr: /\bBlok Çekmece Modülü\b/gi, en: "Drawer Block Module" },
    { tr: /\bUn ve Şeker Arabası\b/gi, en: "Flour & Sugar Bin Trolley" },
    { tr: /\bBanket Arabası Nötr\b/gi, en: "Neutral Banquet Trolley" },
    { tr: /\bTepsi Kaydırma Rayı\b/gi, en: "Tray Slide Rail" },
    { tr: /\bNötr Servis Ünitesi\b/gi, en: "Neutral Service Unit" },
    { tr: /\bKatı Meyve Sıkacağı\b/gi, en: "Juice Extractor" },
    { tr: /\bFiltresiz Davlumbaz\b/gi, en: "Exhaust Hood without Filters" },
    { tr: /\bKaseler ve Tabaklar\b/gi, en: "Bowls & Plates" },
    { tr: /\bGastronorm Küvetler\b/gi, en: "Gastronorm Containers" },
    { tr: /\bBambu Çelik Ürünler\b/gi, en: "Bamboo Steel Products" },
    { tr: /\bPasta Börek Fırını\b/gi, en: "Pastry & Bakery Oven" },
    { tr: /\bEl Blender Çırpıcı\b/gi, en: "Hand Blender Whisk" },
    { tr: /\bStreçleme Makinesi\b/gi, en: "Stretch Film Wrapping Machine" },
    { tr: /\bKaynatma Tenceresi\b/gi, en: "Boiling Pan" },
    { tr: /\bDöner Kesme Bıçağı\b/gi, en: "Electric Doner Knife" },
    { tr: /\bTaban ve Ara Raflı\b/gi, en: "with Bottom & Intermediate Shelf" },
    { tr: /\bAra ve Taban Raflı\b/gi, en: "with Intermediate & Bottom Shelf" },
    { tr: /\bPolietilen Tablalı\b/gi, en: "with Polyethylene Top" },
    { tr: /\bNarenciye Sıkacağı\b/gi, en: "Citrus Juicer" },
    { tr: /\bBuz Kırma Makinesi\b/gi, en: "Ice Crusher" },
    { tr: /\bOrta Tip Davlumbaz\b/gi, en: "Island Type Exhaust Hood" },
    { tr: /\bFiltreli Davlumbaz\b/gi, en: "Exhaust Hood with Filters" },
    { tr: /\bÇay Bardağı Tabağı\b/gi, en: "Tea Coaster / Saucer" },
    { tr: /\bÇatal Bıçak Takımı\b/gi, en: "Cutlery Set" },
    { tr: /\bKızartma Tenceresi\b/gi, en: "Deep Frying Pot" },
    { tr: /\bTuzluk ve Biberlik\b/gi, en: "Salt & Pepper Set" },
    { tr: /\bYağlık ve Sirkelik\b/gi, en: "Oil & Vinegar Set" },
    { tr: /\bYardımcı Makineler\b/gi, en: "Auxiliary Machines" },
    { tr: /\bPolietilen Ürünler\b/gi, en: "Polyethylene Products" },
    { tr: /\bDijital Göstergeli\b/gi, en: "with Digital Display" },
    { tr: /\bIsı Geri Dönüşümlü\b/gi, en: "with Heat Recovery" },
    { tr: /\bPatisserie Fırını\b/gi, en: "Patisserie Oven" },
    { tr: /\bEkmek Dilimleyici\b/gi, en: "Bread Slicer" },
    { tr: /\bEt Kıyma Makinesi\b/gi, en: "Meat Grinder" },
    { tr: /\bEt Kıyma Makinası\b/gi, en: "Meat Grinder" },
    { tr: /\bDik Tip Buzdolabı\b/gi, en: "Upright Refrigerator" },
    { tr: /\bDik Tip Dondurucu\b/gi, en: "Upright Freezer" },
    { tr: /\bDondurma Makinesi\b/gi, en: "Ice Cream Machine" },
    { tr: /\bPaslanmaz Düz Raf\b/gi, en: "Stainless Steel Flat Shelf" },
    { tr: /\bGaloş Bone Dolabı\b/gi, en: "Shoe Cover & Hairnet Cabinet" },
    { tr: /\bPaslanmaz Tablalı\b/gi, en: "with Stainless Top" },
    { tr: /\bSelf Servis Hattı\b/gi, en: "Self Service Line" },
    { tr: /\bİçecek Makineleri\b/gi, en: "Beverage Machines" },
    { tr: /\bZeytinyağı Şişesi\b/gi, en: "Olive Oil Bottle" },
    { tr: /\bDemir Döküm Sunum\b/gi, en: "Cast Iron Presentation Plate" },
    { tr: /\bDijital Göstegeli\b/gi, en: "with Digital Display" },
    { tr: /\bParlatıcı Pompalı\b/gi, en: "with Rinse Aid Pump" },
    { tr: /\bKütahya Porselen\b/gi, en: "Kütahya Porcelain" },
    { tr: /\bBy Bone Porselen\b/gi, en: "By Bone Porcelain" },
    { tr: /\bID Fine Porselen\b/gi, en: "ID Fine Porcelain" },
    { tr: /\bPorland Porselen\b/gi, en: "Porland Porcelain" },
    { tr: /\bAltınbaşak Döküm\b/gi, en: "Altınbaşak Cast Iron" },
    { tr: /\bBulaşık Makinesi\b/gi, en: "Dishwasher" },
    { tr: /\bBulaşık Makinası\b/gi, en: "Dishwasher" },
    { tr: /\bKonveyörlü Fırın\b/gi, en: "Conveyor Oven" },
    { tr: /\bMikrodalga Fırın\b/gi, en: "Microwave Oven" },
    { tr: /\bFırın Makineleri\b/gi, en: "Bakery Machinery" },
    { tr: /\bGıda Öğütücüleri\b/gi, en: "Food Grinders" },
    { tr: /\bPlanet Mikserler\b/gi, en: "Planetary Mixers" },
    { tr: /\bPaneleme Ünitesi\b/gi, en: "Breading Unit" },
    { tr: /\bŞok Dondurucular\b/gi, en: "Blast Chillers & Freezers" },
    { tr: /\bKar Buz Makinesi\b/gi, en: "Flake Ice Machine" },
    { tr: /\bKüp Buz Makinesi\b/gi, en: "Cube Ice Machine" },
    { tr: /\bDevrilir Tavalar\b/gi, en: "Tilting Bratt Pans" },
    { tr: /\bMakarna Pişirici\b/gi, en: "Pasta Cooker" },
    { tr: /\bLavataşlı Izgara\b/gi, en: "Lava Rock Grill" },
    { tr: /\bTel Izgaralı Raf\b/gi, en: "Wire Grate Shelf" },
    { tr: /\bEl Yıkama Evyesi\b/gi, en: "Hand Wash Sink" },
    { tr: /\bServis Arabaları\b/gi, en: "Service Trolleys" },
    { tr: /\bMutfak Arabaları\b/gi, en: "Kitchen Trolleys" },
    { tr: /\bAçık Büfe Teşhir\b/gi, en: "Open Buffet Display" },
    { tr: /\bDikdörtgen Tabak\b/gi, en: "Rectangular Plate" },
    { tr: /\bBölmeli Tabaklar\b/gi, en: "Compartment Plates" },
    { tr: /\bEspresso Fincanı\b/gi, en: "Espresso Cup" },
    { tr: /\bKapuçino Fincanı\b/gi, en: "Cappuccino Cup" },
    { tr: /\bMeşrubat Bardağı\b/gi, en: "Beverage Tumbler" },
    { tr: /\bGastronorm Küvet\b/gi, en: "Gastronorm Container" },
    { tr: /\bPeçetelik Takımı\b/gi, en: "Napkin Holder Set" },
    { tr: /\bYardımcı Ürünler\b/gi, en: "Auxiliary Products" },
    { tr: /\bDeterjan Pompalı\b/gi, en: "with Detergent Pump" },
    { tr: /\bTabak Kapasiteli\b/gi, en: "Plates Capacity" },
    { tr: /\bPizza Fırınları\b/gi, en: "Pizza Ovens" },
    { tr: /\bMayalama Kabini\b/gi, en: "Proofer Cabinet" },
    { tr: /\bKemik Testeresi\b/gi, en: "Bone Saw" },
    { tr: /\bOtomatik Fritöz\b/gi, en: "Automatic Fryer" },
    { tr: /\bWaffle Makinesi\b/gi, en: "Waffle Maker" },
    { tr: /\bÇalışma Tezgahı\b/gi, en: "Worktable" },
    { tr: /\bIsıtıcı Modüllü\b/gi, en: "with Heated Module" },
    { tr: /\bPaslanmaz Yüzey\b/gi, en: "Stainless Steel Surface" },
    { tr: /\bKahvaltı Tabağı\b/gi, en: "Breakfast Plate" },
    { tr: /\bKomposto Kasesi\b/gi, en: "Compote Bowl" },
    { tr: /\bKokteyl Bardağı\b/gi, en: "Cocktail Glass" },
    { tr: /\bŞampanya Kadehi\b/gi, en: "Champagne Flute" },
    { tr: /\bŞampanya Kovası\b/gi, en: "Champagne Bucket" },
    { tr: /\bPasta Spatulası\b/gi, en: "Pastry Spatula" },
    { tr: /\bDondurma Kaşığı\b/gi, en: "Ice Cream Scoop" },
    { tr: /\bYeşillik Makası\b/gi, en: "Herb Scissors" },
    { tr: /\bSaklama Kapları\b/gi, en: "Storage Containers" },
    { tr: /\bSpagetti Maşası\b/gi, en: "Spaghetti Tong" },
    { tr: /\bKızartma Tavası\b/gi, en: "Frying Pan" },
    { tr: /\bKızartma Sepeti\b/gi, en: "Fry Basket" },
    { tr: /\bAyaklı Sunumlar\b/gi, en: "Pedestal Display Stands" },
    { tr: /\bPaslanmaz Çelik\b/gi, en: "Stainless Steel" },
    { tr: /\bTahliye Pompalı\b/gi, en: "with Drain Pump" },
    { tr: /\bGüral Porselen\b/gi, en: "Güral Porcelain" },
    { tr: /\bBonna Porselen\b/gi, en: "Bonna Porcelain" },
    { tr: /\bJumbo Porselen\b/gi, en: "Jumbo Porcelain" },
    { tr: /\bKılıçlar Çatal\b/gi, en: "Kılıçlar Cutlery" },
    { tr: /\bKombi Fırınlar\b/gi, en: "Combi Ovens" },
    { tr: /\bFırın Makinesi\b/gi, en: "Bakery Machine" },
    { tr: /\bGıda Öğütücüsü\b/gi, en: "Food Grinder" },
    { tr: /\bSalata Tezgahı\b/gi, en: "Saladette Counter" },
    { tr: /\bÇalışma Masası\b/gi, en: "Worktable" },
    { tr: /\bÇekmece Modülü\b/gi, en: "Drawer Module" },
    { tr: /\bMermer Tablalı\b/gi, en: "with Marble Top" },
    { tr: /\bGranit Tablalı\b/gi, en: "with Granite Top" },
    { tr: /\bServis Arabası\b/gi, en: "Service Trolley" },
    { tr: /\bMutfak Arabası\b/gi, en: "Kitchen Trolley" },
    { tr: /\bPlatform Araba\b/gi, en: "Platform Trolley" },
    { tr: /\bBanket Arabası\b/gi, en: "Banquet Trolley" },
    { tr: /\bSoğutma Havuzu\b/gi, en: "Cooling Well" },
    { tr: /\bHijyen Paspası\b/gi, en: "Hygiene Mat" },
    { tr: /\bKahve Makinesi\b/gi, en: "Coffee Machine" },
    { tr: /\bAyran Makinesi\b/gi, en: "Ayran Dispenser" },
    { tr: /\bFincan Isıtıcı\b/gi, en: "Cup Warmer" },
    { tr: /\bYer Izgaraları\b/gi, en: "Floor Drainage Grates" },
    { tr: /\bKonsome Tabağı\b/gi, en: "Consomme Saucer" },
    { tr: /\bMakarna Tabağı\b/gi, en: "Pasta Plate" },
    { tr: /\bDönen Tabaklar\b/gi, en: "Rotating Serving Plates" },
    { tr: /\bSıyırma Bıçağı\b/gi, en: "Boning Knife" },
    { tr: /\bDoğrama Bıçağı\b/gi, en: "Chopping Knife" },
    { tr: /\bKokteyl Kaşığı\b/gi, en: "Cocktail Spoon" },
    { tr: /\bPeynir Tahtası\b/gi, en: "Cheese Board" },
    { tr: /\bKünefe Tepsisi\b/gi, en: "Kunefe Plate" },
    { tr: /\bDüzenleyiciler\b/gi, en: "Organizers" },
    { tr: /\bPorselen Grubu\b/gi, en: "Porcelain Group" },
    { tr: /\bTeşhir Vitrini\b/gi, en: "Display Showcase" },
    { tr: /\bTaşıma Arabası\b/gi, en: "Transport Trolley" },
    { tr: /\bTabanlı Fırın\b/gi, en: "Deck Oven" },
    { tr: /\bPlanet Mikser\b/gi, en: "Planetary Mixer" },
    { tr: /\bŞok Dondurucu\b/gi, en: "Blast Chiller / Freezer" },
    { tr: /\bŞişe Soğutucu\b/gi, en: "Bottle Cooler" },
    { tr: /\bDevrilir Tava\b/gi, en: "Tilting Bratt Pan" },
    { tr: /\bOluklu Izgara\b/gi, en: "Ribbed Griddle" },
    { tr: /\bÇiftli Fritöz\b/gi, en: "Double Tank Fryer" },
    { tr: /\bKrep Makinesi\b/gi, en: "Crepe Maker" },
    { tr: /\bTost Makinesi\b/gi, en: "Contact Grill / Panini Grill" },
    { tr: /\bİstif Rafları\b/gi, en: "Storage Racks" },
    { tr: /\bPaslanmaz Raf\b/gi, en: "Stainless Steel Shelf" },
    { tr: /\bEvyeli Tezgah\b/gi, en: "Sink Table" },
    { tr: /\bÇarpma Kapılı\b/gi, en: "with Hinged Doors" },
    { tr: /\bKaydırma Rayı\b/gi, en: "Slide Rail" },
    { tr: /\bKuver Ünitesi\b/gi, en: "Cutlery & Bread Dispenser Unit" },
    { tr: /\bIsıtma Havuzu\b/gi, en: "Heated Well" },
    { tr: /\bGranite Yüzey\b/gi, en: "Granite Surface" },
    { tr: /\bBölmeli Tabak\b/gi, en: "Compartment Plate" },
    { tr: /\bServis Tabağı\b/gi, en: "Serving Plate / Charger" },
    { tr: /\bSalata Kasesi\b/gi, en: "Salad Bowl" },
    { tr: /\bKahve Fincanı\b/gi, en: "Coffee Cup" },
    { tr: /\bFincan Tabağı\b/gi, en: "Cup Saucer" },
    { tr: /\bŞarap Bardağı\b/gi, en: "Wine Glass" },
    { tr: /\bViski Bardağı\b/gi, en: "Whiskey Glass" },
    { tr: /\bServis Kaşığı\b/gi, en: "Serving Spoon" },
    { tr: /\bServis Çatalı\b/gi, en: "Serving Fork" },
    { tr: /\bServis Bıçağı\b/gi, en: "Serving Knife" },
    { tr: /\bServis Küreği\b/gi, en: "Cake Server / Shovel" },
    { tr: /\bMutfak Makası\b/gi, en: "Kitchen Shears" },
    { tr: /\bKesme Tahtası\b/gi, en: "Cutting Board" },
    { tr: /\bSteak Tahtası\b/gi, en: "Steak Board" },
    { tr: /\bSunum Tahtası\b/gi, en: "Serving Board" },
    { tr: /\bPizza Tahtası\b/gi, en: "Pizza Board" },
    { tr: /\bDelikli Küvet\b/gi, en: "Perforated Container" },
    { tr: /\bÖlçülü Kaplar\b/gi, en: "Measuring Jugs & Cups" },
    { tr: /\bSalata Maşası\b/gi, en: "Salad Tong" },
    { tr: /\bKünefe Tabağı\b/gi, en: "Kunefe Plate" },
    { tr: /\bBakır Tavalar\b/gi, en: "Copper Pans" },
    { tr: /\bBaharatlıklar\b/gi, en: "Spice Dispensers & Shakers" },
    { tr: /\bDiğer Ürünler\b/gi, en: "Other Products" },
    { tr: /\bOrdövr Tabağı\b/gi, en: "Hors d'oeuvre Plate" },
    { tr: /\bAhşap Ürünler\b/gi, en: "Wooden Products" },
    { tr: /\bAkrilik Grubu\b/gi, en: "Acrylic Group" },
    { tr: /\bMelamin Grubu\b/gi, en: "Melamine Group" },
    { tr: /\bButonlu Model\b/gi, en: "Button Model" },
    { tr: /\bTeşhir Dolabı\b/gi, en: "Display Cabinet" },
    { tr: /\bBahşiş Kutusu\b/gi, en: "Tip Box" },
    { tr: /\bPizza Fırını\b/gi, en: "Pizza Oven" },
    { tr: /\bStatik Fırın\b/gi, en: "Static Oven" },
    { tr: /\bŞok Soğutucu\b/gi, en: "Blast Chiller" },
    { tr: /\bPasta Dolabı\b/gi, en: "Pastry Display Showcase" },
    { tr: /\bBuz Makinesi\b/gi, en: "Ice Machine" },
    { tr: /\bDondurucular\b/gi, en: "Freezers" },
    { tr: /\bSoğuk Odalar\b/gi, en: "Cold Rooms" },
    { tr: /\bŞarap Dolabı\b/gi, en: "Wine Cabinet" },
    { tr: /\bYer Ocakları\b/gi, en: "Stock Pot Stoves" },
    { tr: /\bSıcak Tutucu\b/gi, en: "Warm Holding Unit" },
    { tr: /\bDöküm Izgara\b/gi, en: "Cast Iron Griddle" },
    { tr: /\bTekli Fritöz\b/gi, en: "Single Tank Fryer" },
    { tr: /\bDöner Robotu\b/gi, en: "Automatic Doner Cutting Robot" },
    { tr: /\bDuvar Dolabı\b/gi, en: "Wall Cupboard" },
    { tr: /\bEkmek Dolabı\b/gi, en: "Bread Cabinet" },
    { tr: /\bKöşe Ünitesi\b/gi, en: "Corner Unit" },
    { tr: /\bTaban Rafsız\b/gi, en: "without Bottom Shelf" },
    { tr: /\bSürgü Kapılı\b/gi, en: "with Sliding Doors" },
    { tr: /\bÇay Makinesi\b/gi, en: "Tea Brewing Machine" },
    { tr: /\bDavlumbazlar\b/gi, en: "Exhaust Hoods" },
    { tr: /\bYer Izgarası\b/gi, en: "Floor Drainage Grate" },
    { tr: /\bKonsome Kase\b/gi, en: "Consomme Bowl" },
    { tr: /\bPizza Tabağı\b/gi, en: "Pizza Plate" },
    { tr: /\bPasta Tabağı\b/gi, en: "Pastry / Cake Plate" },
    { tr: /\bEkmek Tabağı\b/gi, en: "Bread Plate" },
    { tr: /\bYemek Tabağı\b/gi, en: "Dinner Plate" },
    { tr: /\bTatlı Tabağı\b/gi, en: "Dessert Plate" },
    { tr: /\bBalık Tabağı\b/gi, en: "Fish Plate" },
    { tr: /\bÇorba Kasesi\b/gi, en: "Soup Bowl" },
    { tr: /\bMeyve Kasesi\b/gi, en: "Fruit Bowl" },
    { tr: /\bYemek Kasesi\b/gi, en: "Serving Bowl" },
    { tr: /\bŞarap Kadehi\b/gi, en: "Wine Glass" },
    { tr: /\bŞarap Kovası\b/gi, en: "Wine Bucket" },
    { tr: /\bBira Bardağı\b/gi, en: "Beer Glass" },
    { tr: /\bLikör Kadehi\b/gi, en: "Liqueur Glass" },
    { tr: /\bYemek Kaşığı\b/gi, en: "Dinner Spoon" },
    { tr: /\bYemek Çatalı\b/gi, en: "Dinner Fork" },
    { tr: /\bYemek Bıçağı\b/gi, en: "Dinner Knife" },
    { tr: /\bTatlı Kaşığı\b/gi, en: "Dessert Spoon" },
    { tr: /\bTatlı Çatalı\b/gi, en: "Dessert Fork" },
    { tr: /\bTatlı Bıçağı\b/gi, en: "Dessert Knife" },
    { tr: /\bKahve Kaşığı\b/gi, en: "Coffee Spoon" },
    { tr: /\bBalık Çatalı\b/gi, en: "Fish Fork" },
    { tr: /\bBalık Bıçağı\b/gi, en: "Fish Knife" },
    { tr: /\bSteak Bıçağı\b/gi, en: "Steak Knife" },
    { tr: /\bEkmek Bıçağı\b/gi, en: "Bread Knife" },
    { tr: /\bSoyma Bıçağı\b/gi, en: "Paring Knife" },
    { tr: /\bSürme Bıçağı\b/gi, en: "Butter Spreader Knife" },
    { tr: /\bPasta Küreği\b/gi, en: "Cake Server" },
    { tr: /\bPasta Bıçağı\b/gi, en: "Pastry Knife" },
    { tr: /\bTavuk Makası\b/gi, en: "Poultry Shears" },
    { tr: /\bSaklama Kabı\b/gi, en: "Storage Container" },
    { tr: /\bPasta Maşası\b/gi, en: "Pastry Tong" },
    { tr: /\bPizza Küreği\b/gi, en: "Pizza Peel" },
    { tr: /\bFırın Küreği\b/gi, en: "Oven Peel" },
    { tr: /\bKavurma Sacı\b/gi, en: "Roasting Pan / Wok Disc" },
    { tr: /\bAyaklı Sunum\b/gi, en: "Pedestal Stand" },
    { tr: /\bMeşe Fıçılar\b/gi, en: "Oak Barrels" },
    { tr: /\bToprak Grubu\b/gi, en: "Earthenware & Clay Group" },
    { tr: /\bPolikarbonat\b/gi, en: "Polycarbonate" },
    { tr: /\bİndüksiyonlu\b/gi, en: "Induction" },
    { tr: /\bKombi Fırın\b/gi, en: "Combi Oven" },
    { tr: /\bEl Blenderı\b/gi, en: "Hand Blender" },
    { tr: /\bEl Blenderi\b/gi, en: "Hand Blender" },
    { tr: /\bDöner Ocağı\b/gi, en: "Doner Kebab Gyro Machine" },
    { tr: /\bPişiriciler\b/gi, en: "Cooking Equipment" },
    { tr: /\bTaban Raflı\b/gi, en: "with Bottom Shelf" },
    { tr: /\bSelf Servis\b/gi, en: "Self Service" },
    { tr: /\bMobil Stand\b/gi, en: "Mobile Stand" },
    { tr: /\bÇay Otomatı\b/gi, en: "Tea Dispenser / Urn" },
    { tr: /\bYer Süzgeci\b/gi, en: "Floor Drain" },
    { tr: /\bKayık Tabak\b/gi, en: "Boat / Oval Plate" },
    { tr: /\bÇukur Tabak\b/gi, en: "Deep Plate" },
    { tr: /\bDönen Tabak\b/gi, en: "Rotating Serving Plate" },
    { tr: /\bMeze Tabağı\b/gi, en: "Appetizer Plate" },
    { tr: /\bÇay Fincanı\b/gi, en: "Tea Cup" },
    { tr: /\bÇay Bardağı\b/gi, en: "Tea Glass" },
    { tr: /\bÇay Demliği\b/gi, en: "Teapot" },
    { tr: /\bKahvedanlık\b/gi, en: "Coffee Pot" },
    { tr: /\bBambu Bıçak\b/gi, en: "Bamboo Knife" },
    { tr: /\bGarnitürlük\b/gi, en: "Garnish Dispenser" },
    { tr: /\bDüzenleyici\b/gi, en: "Organizer" },
    { tr: /\bAhşap Grubu\b/gi, en: "Wooden Group" },
    { tr: /\bBakır Grubu\b/gi, en: "Copper Group" },
    { tr: /\bDöküm Grubu\b/gi, en: "Cast Iron Group" },
    { tr: /\bSol Girişli\b/gi, en: "Left Entry" },
    { tr: /\bSağ Girişli\b/gi, en: "Right Entry" },
    { tr: /\bFırçalanmış\b/gi, en: "Brushed" },
    { tr: /\bEkipmanları\b/gi, en: "Equipment" },
    { tr: /\bProfesyonel\b/gi, en: "Professional" },
    { tr: /\bEndüstriyel\b/gi, en: "Industrial" },
    { tr: /\bEl Mikseri\b/gi, en: "Hand Mixer" },
    { tr: /\bDüz Izgara\b/gi, en: "Flat Griddle" },
    { tr: /\bBenmariler\b/gi, en: "Bain Maries" },
    { tr: /\bSalamander\b/gi, en: "Salamander Grill" },
    { tr: /\bAra Tezgah\b/gi, en: "Intermediate Worktable" },
    { tr: /\bYan Tezgah\b/gi, en: "Side Table" },
    { tr: /\bDuvar Rafı\b/gi, en: "Wall Shelf" },
    { tr: /\bİstif Rafı\b/gi, en: "Storage Rack" },
    { tr: /\bAra Rafsız\b/gi, en: "without Intermediate Shelf" },
    { tr: /\bTek Evyeli\b/gi, en: "Single Sink" },
    { tr: /\bİki Evyeli\b/gi, en: "Double Sink" },
    { tr: /\bDamlalıklı\b/gi, en: "with Drainer" },
    { tr: /\bÇift Katlı\b/gi, en: "Double Tier" },
    { tr: /\bDört Katlı\b/gi, en: "Four Tier" },
    { tr: /\bÇay Kazanı\b/gi, en: "Tea Boiler" },
    { tr: /\bKare Tabak\b/gi, en: "Square Plate" },
    { tr: /\bOval Tabak\b/gi, en: "Oval Plate" },
    { tr: /\bSos Kasesi\b/gi, en: "Sauce Bowl" },
    { tr: /\bSu Bardağı\b/gi, en: "Water Glass" },
    { tr: /\bŞarap Kova\b/gi, en: "Wine Bucket" },
    { tr: /\bÇay Kaşığı\b/gi, en: "Tea Spoon" },
    { tr: /\bÇay Demlik\b/gi, en: "Teapot" },
    { tr: /\bŞef Bıçağı\b/gi, en: "Chef Knife" },
    { tr: /\bÖlçülü Kap\b/gi, en: "Measuring Jug / Cup" },
    { tr: /\bErzak Kabı\b/gi, en: "Food Storage Bin" },
    { tr: /\bBuz Maşası\b/gi, en: "Ice Tong" },
    { tr: /\bSpatulalar\b/gi, en: "Spatulas" },
    { tr: /\bÇırpıcılar\b/gi, en: "Whisks" },
    { tr: /\bTencereler\b/gi, en: "Pots" },
    { tr: /\bZeytinyağı\b/gi, en: "Olive Oil" },
    { tr: /\bBakır Tava\b/gi, en: "Copper Pan" },
    { tr: /\bBaharatlık\b/gi, en: "Spice Dispenser" },
    { tr: /\bAşk Serisi\b/gi, en: "Love Series" },
    { tr: /\bPolietilen\b/gi, en: "Polyethylene" },
    { tr: /\bPolikarbon\b/gi, en: "Polycarbonate" },
    { tr: /\bKapasiteli\b/gi, en: "Capacity" },
    { tr: /\bElektrikli\b/gi, en: "Electric" },
    { tr: /\bDoğalgazlı\b/gi, en: "Natural Gas" },
    { tr: /\bİndüksiyon\b/gi, en: "Induction" },
    { tr: /\bYumurtalık\b/gi, en: "Egg Cup" },
    { tr: /\bBuzdolabı\b/gi, en: "Refrigerator" },
    { tr: /\bDondurucu\b/gi, en: "Freezer" },
    { tr: /\bSoğuk Oda\b/gi, en: "Cold Room" },
    { tr: /\bYer Ocağı\b/gi, en: "Stock Pot Stove" },
    { tr: /\bFritözler\b/gi, en: "Deep Fryers" },
    { tr: /\bKuzineler\b/gi, en: "Ranges" },
    { tr: /\bIzgaralar\b/gi, en: "Griddles / Grills" },
    { tr: /\bAra Raflı\b/gi, en: "with Intermediate Shelf" },
    { tr: /\bÜç Evyeli\b/gi, en: "Triple Sink" },
    { tr: /\bTek Katlı\b/gi, en: "Single Tier" },
    { tr: /\bAçık Büfe\b/gi, en: "Open Buffet" },
    { tr: /\bMobil Bar\b/gi, en: "Mobile Bar" },
    { tr: /\bŞerbetlik\b/gi, en: "Cold Drink Dispenser" },
    { tr: /\bSu Sebili\b/gi, en: "Water Dispenser" },
    { tr: /\bDavlumbaz\b/gi, en: "Exhaust Hood" },
    { tr: /\bDüz Tabak\b/gi, en: "Flat Plate" },
    { tr: /\bBardaklar\b/gi, en: "Glasses" },
    { tr: /\bÇaydanlık\b/gi, en: "Teapot Kettle Set" },
    { tr: /\b5 Bıçaklı\b/gi, en: "5-Blade" },
    { tr: /\bÖlçü Kabı\b/gi, en: "Measuring Jug / Cup" },
    { tr: /\bEt Maşası\b/gi, en: "Meat Tong" },
    { tr: /\bKevgirler\b/gi, en: "Skimmers" },
    { tr: /\bSpatulası\b/gi, en: "Spatula" },
    { tr: /\bSüzgeçler\b/gi, en: "Strainers & Colanders" },
    { tr: /\bÇırpıcısı\b/gi, en: "Whisk" },
    { tr: /\bTenceresi\b/gi, en: "Pot" },
    { tr: /\bDeğirmeni\b/gi, en: "Grinder / Mill" },
    { tr: /\bMeşe Fıçı\b/gi, en: "Oak Barrel" },
    { tr: /\bPeçetelik\b/gi, en: "Napkin Holder" },
    { tr: /\bKürdanlık\b/gi, en: "Toothpick Holder" },
    { tr: /\bCam Grubu\b/gi, en: "Glass Group" },
    { tr: /\bPaslanmaz\b/gi, en: "Stainless Steel" },
    { tr: /\bMobilyalı\b/gi, en: "with Wood Cladding" },
    { tr: /\bKaplamalı\b/gi, en: "Coated" },
    { tr: /\bBrulörler\b/gi, en: "Burners" },
    { tr: /\bÜniteleri\b/gi, en: "Units" },
    { tr: /\bYükseklik\b/gi, en: "Height" },
    { tr: /\bBasamaklı\b/gi, en: "Stepped" },
    { tr: /\bKüçük Boy\b/gi, en: "Small Size" },
    { tr: /\bBüyük Boy\b/gi, en: "Large Size" },
    { tr: /\bFırınlar\b/gi, en: "Ovens" },
    { tr: /\bDamlalık\b/gi, en: "Drainer" },
    { tr: /\bÖnü Açık\b/gi, en: "Open Front" },
    { tr: /\bÜç Katlı\b/gi, en: "Triple Tier" },
    { tr: /\bTabaklar\b/gi, en: "Plates" },
    { tr: /\bÇorbalık\b/gi, en: "Soup Tureen / Bowl" },
    { tr: /\bMeşrubat\b/gi, en: "Beverage" },
    { tr: /\bŞampanya\b/gi, en: "Champagne" },
    { tr: /\bKadehler\b/gi, en: "Glasses / Stemware" },
    { tr: /\bKaşıklar\b/gi, en: "Spoons" },
    { tr: /\bÇatallar\b/gi, en: "Forks" },
    { tr: /\bBıçaklar\b/gi, en: "Knives" },
    { tr: /\bBileyici\b/gi, en: "Sharpener" },
    { tr: /\bKepçeler\b/gi, en: "Ladles" },
    { tr: /\bRendeler\b/gi, en: "Graters" },
    { tr: /\bKaçerola\b/gi, en: "Casserole / Saucepan" },
    { tr: /\bKaçarola\b/gi, en: "Casserole / Saucepan" },
    { tr: /\bKızartma\b/gi, en: "Frying" },
    { tr: /\bTepsiler\b/gi, en: "Trays" },
    { tr: /\bDeğirmen\b/gi, en: "Grinder / Mill" },
    { tr: /\bBiberlik\b/gi, en: "Pepper Shaker" },
    { tr: /\bŞekerlik\b/gi, en: "Sugar Bowl" },
    { tr: /\bSirkelik\b/gi, en: "Vinegar Dispenser / Cruet" },
    { tr: /\bReçellik\b/gi, en: "Jam Dish" },
    { tr: /\bYardımcı\b/gi, en: "Auxiliary" },
    { tr: /\bPorselen\b/gi, en: "Porcelain" },
    { tr: /\bTabaklık\b/gi, en: "Plates Capacity" },
    { tr: /\bKapasite\b/gi, en: "Capacity" },
    { tr: /\bElektrik\b/gi, en: "Electric" },
    { tr: /\bAntrasit\b/gi, en: "Anthracite" },
    { tr: /\bKapaksız\b/gi, en: "without Lid" },
    { tr: /\bBrulörlü\b/gi, en: "with Burner" },
    { tr: /\bSet Üstü\b/gi, en: "Countertop" },
    { tr: /\bSet Altı\b/gi, en: "Undercounter" },
    { tr: /\bStandsız\b/gi, en: "without Stand" },
    { tr: /\bEkipmanı\b/gi, en: "Equipment" },
    { tr: /\bGenişlik\b/gi, en: "Width" },
    { tr: /\bDerinlik\b/gi, en: "Depth" },
    { tr: /\bLavtaşlı\b/gi, en: "Lava Rock" },
    { tr: /\bNervürlü\b/gi, en: "Ribbed" },
    { tr: /\bYapışmaz\b/gi, en: "Non-Stick" },
    { tr: /\bÖzelliği\b/gi, en: "Feature" },
    { tr: /\bKalınlık\b/gi, en: "Thickness" },
    { tr: /\bOrta Boy\b/gi, en: "Medium Size" },
    { tr: /\bDeliksiz\b/gi, en: "Solid" },
    { tr: /\bEkonomik\b/gi, en: "Economy" },
    { tr: /\bStandart\b/gi, en: "Standard" },
    { tr: /\bFırınlı\b/gi, en: "with Oven" },
    { tr: /\bOcaklar\b/gi, en: "Cooktops / Burners" },
    { tr: /\bBenmari\b/gi, en: "Bain Marie" },
    { tr: /\bDüz Raf\b/gi, en: "Flat Shelf" },
    { tr: /\bTel Raf\b/gi, en: "Wire Shelf" },
    { tr: /\bSırtsız\b/gi, en: "without Upstand" },
    { tr: /\bSırtlık\b/gi, en: "Upstand" },
    { tr: /\bÖn Açık\b/gi, en: "Open Front" },
    { tr: /\bKaseler\b/gi, en: "Bowls" },
    { tr: /\bFincanı\b/gi, en: "Cup" },
    { tr: /\bBardağı\b/gi, en: "Glass" },
    { tr: /\bDemliği\b/gi, en: "Teapot" },
    { tr: /\bBıçaklı\b/gi, en: "Blade" },
    { tr: /\bMaşalar\b/gi, en: "Tongs" },
    { tr: /\bKevgiri\b/gi, en: "Skimmer" },
    { tr: /\bKepçesi\b/gi, en: "Ladle" },
    { tr: /\bSpatula\b/gi, en: "Spatula" },
    { tr: /\bSüzgeci\b/gi, en: "Strainer / Colander" },
    { tr: /\bÇırpıcı\b/gi, en: "Whisk" },
    { tr: /\bRendesi\b/gi, en: "Grater" },
    { tr: /\bHuniler\b/gi, en: "Funnels" },
    { tr: /\bTencere\b/gi, en: "Pot" },
    { tr: /\bTavalar\b/gi, en: "Pans" },
    { tr: /\bTepsisi\b/gi, en: "Tray" },
    { tr: /\bSosluğu\b/gi, en: "Sauce Dish" },
    { tr: /\bSeramik\b/gi, en: "Ceramic" },
    { tr: /\bMelamin\b/gi, en: "Melamine" },
    { tr: /\bAkrilik\b/gi, en: "Acrylic" },
    { tr: /\bKırmızı\b/gi, en: "Red" },
    { tr: /\bKapaklı\b/gi, en: "with Lid" },
    { tr: /\bKulpsuz\b/gi, en: "without Handle" },
    { tr: /\bTabanlı\b/gi, en: "with Base" },
    { tr: /\bÇıkışlı\b/gi, en: "Outlet" },
    { tr: /\bGirişli\b/gi, en: "Inlet" },
    { tr: /\bDışında\b/gi, en: "Excluded / Outside" },
    { tr: /\bSetüstü\b/gi, en: "Countertop" },
    { tr: /\bSetaltı\b/gi, en: "Undercounter" },
    { tr: /\bStandlı\b/gi, en: "with Stand" },
    { tr: /\bÜnitesi\b/gi, en: "Unit" },
    { tr: /\bEkipman\b/gi, en: "Equipment" },
    { tr: /\bÖlçüler\b/gi, en: "Dimensions" },
    { tr: /\bAğırlık\b/gi, en: "Weight" },
    { tr: /\bLavtaşı\b/gi, en: "Lava Rock" },
    { tr: /\bKürdanı\b/gi, en: "Toothpick" },
    { tr: /\bLevhası\b/gi, en: "Plate / Sign" },
    { tr: /\bÖzellik\b/gi, en: "Feature" },
    { tr: /\bKapılar\b/gi, en: "Doors" },
    { tr: /\bArkadan\b/gi, en: "Back" },
    { tr: /\bDelikli\b/gi, en: "Perforated" },
    { tr: /\bFırını\b/gi, en: "Oven" },
    { tr: /\bFritöz\b/gi, en: "Deep Fryer" },
    { tr: /\bKuzine\b/gi, en: "Range / Cooktop with Oven" },
    { tr: /\bIzgara\b/gi, en: "Griddle / Grill" },
    { tr: /\bSırtlı\b/gi, en: "with Upstand" },
    { tr: /\bEvyeli\b/gi, en: "with Sink" },
    { tr: /\bTabağı\b/gi, en: "Plate / Saucer" },
    { tr: /\bKasesi\b/gi, en: "Bowl" },
    { tr: /\bFincan\b/gi, en: "Cup" },
    { tr: /\bBardak\b/gi, en: "Glass" },
    { tr: /\bDemlik\b/gi, en: "Teapot" },
    { tr: /\bKaşığı\b/gi, en: "Spoon" },
    { tr: /\bÇatalı\b/gi, en: "Fork" },
    { tr: /\bBıçağı\b/gi, en: "Knife" },
    { tr: /\bKevgir\b/gi, en: "Skimmer" },
    { tr: /\bSüzgeç\b/gi, en: "Strainer / Colander" },
    { tr: /\bHunisi\b/gi, en: "Funnel" },
    { tr: /\bAçacak\b/gi, en: "Opener" },
    { tr: /\bSahanı\b/gi, en: "Serving Pan / Sahan" },
    { tr: /\bTavası\b/gi, en: "Pan" },
    { tr: /\bSürahi\b/gi, en: "Pitcher / Carafe" },
    { tr: /\bKarafı\b/gi, en: "Carafe" },
    { tr: /\bŞişesi\b/gi, en: "Bottle" },
    { tr: /\bTuzluk\b/gi, en: "Salt Shaker" },
    { tr: /\bKüllük\b/gi, en: "Ashtray" },
    { tr: /\bSütlük\b/gi, en: "Milk Jug / Creamer" },
    { tr: /\bYağlık\b/gi, en: "Oil Dispenser / Cruet" },
    { tr: /\bSosluk\b/gi, en: "Sauce Boat / Dish" },
    { tr: /\bOrdövr\b/gi, en: "Hors d'oeuvre / Appetizer" },
    { tr: /\bGranit\b/gi, en: "Granite" },
    { tr: /\bMermer\b/gi, en: "Marble" },
    { tr: /\bToprak\b/gi, en: "Clay / Earthenware" },
    { tr: /\bLPG li\b/gi, en: "LPG" },
    { tr: /\bBoyalı\b/gi, en: "Painted" },
    { tr: /\bAynalı\b/gi, en: "Mirror Polished" },
    { tr: /\bSapsız\b/gi, en: "without Handle" },
    { tr: /\bKulplu\b/gi, en: "with Handle" },
    { tr: /\bKapalı\b/gi, en: "Enclosed / Closed" },
    { tr: /\bİçinde\b/gi, en: "Included / Inside" },
    { tr: /\bBrulör\b/gi, en: "Burner" },
    { tr: /\bAteşli\b/gi, en: "Burner / Flame" },
    { tr: /\bTeşhir\b/gi, en: "Display" },
    { tr: /\bStandı\b/gi, en: "Stand" },
    { tr: /\bModülü\b/gi, en: "Module" },
    { tr: /\bSerisi\b/gi, en: "Series" },
    { tr: /\bModeli\b/gi, en: "Model" },
    { tr: /\bKalite\b/gi, en: "Grade" },
    { tr: /\bTaşıma\b/gi, en: "Transport / Carrying" },
    { tr: /\bZümrüt\b/gi, en: "Emerald" },
    { tr: /\bYıldız\b/gi, en: "Star" },
    { tr: /\bKürdan\b/gi, en: "Toothpick" },
    { tr: /\bBahşiş\b/gi, en: "Tip" },
    { tr: /\bKöşeli\b/gi, en: "Angular / Corner" },
    { tr: /\bŞelale\b/gi, en: "Waterfall" },
    { tr: /\bÜstten\b/gi, en: "Top" },
    { tr: /\bAlttan\b/gi, en: "Bottom" },
    { tr: /\bYandan\b/gi, en: "Side" },
    { tr: /\bYüksek\b/gi, en: "High" },
    { tr: /\bOluklu\b/gi, en: "Ribbed" },
    { tr: /\bTicari\b/gi, en: "Commercial" },
    { tr: /\bKlasik\b/gi, en: "Classic" },
    { tr: /\bModern\b/gi, en: "Modern" },
    { tr: /\bFırın\b/gi, en: "Oven" },
    { tr: /\bTabak\b/gi, en: "Plate" },
    { tr: /\bÇorba\b/gi, en: "Soup" },
    { tr: /\bŞarap\b/gi, en: "Wine" },
    { tr: /\bKadeh\b/gi, en: "Glass / Goblet" },
    { tr: /\bTatlı\b/gi, en: "Dessert" },
    { tr: /\bCezve\b/gi, en: "Turkish Coffee Pot" },
    { tr: /\bBalık\b/gi, en: "Fish" },
    { tr: /\bKaşık\b/gi, en: "Spoon" },
    { tr: /\bÇatal\b/gi, en: "Fork" },
    { tr: /\bBıçak\b/gi, en: "Knife" },
    { tr: /\bMasat\b/gi, en: "Sharpening Steel" },
    { tr: /\bKepçe\b/gi, en: "Ladle" },
    { tr: /\bRende\b/gi, en: "Grater" },
    { tr: /\bSahan\b/gi, en: "Serving Pan / Sahan" },
    { tr: /\bTepsi\b/gi, en: "Tray" },
    { tr: /\bGüveç\b/gi, en: "Clay Pot / Casserole" },
    { tr: /\bKaraf\b/gi, en: "Carafe" },
    { tr: /\bKürek\b/gi, en: "Peel / Shovel" },
    { tr: /\bBakır\b/gi, en: "Copper" },
    { tr: /\bDöküm\b/gi, en: "Cast Iron" },
    { tr: /\bÇelik\b/gi, en: "Steel" },
    { tr: /\bAhşap\b/gi, en: "Wooden" },
    { tr: /\bBambu\b/gi, en: "Bamboo" },
    { tr: /\bGazlı\b/gi, en: "Gas" },
    { tr: /\bSiyah\b/gi, en: "Black" },
    { tr: /\bBeyaz\b/gi, en: "White" },
    { tr: /\bYeşil\b/gi, en: "Green" },
    { tr: /\bCeviz\b/gi, en: "Walnut" },
    { tr: /\bCamlı\b/gi, en: "with Glass Door / Glass" },
    { tr: /\bSaplı\b/gi, en: "with Handle" },
    { tr: /\bOcağı\b/gi, en: "Cooktop / Stove" },
    { tr: /\bStand\b/gi, en: "Stand" },
    { tr: /\bModül\b/gi, en: "Module" },
    { tr: /\bModel\b/gi, en: "Model" },
    { tr: /\bParça\b/gi, en: "Pieces" },
    { tr: /\bTakım\b/gi, en: "Set" },
    { tr: /\bÜnite\b/gi, en: "Unit" },
    { tr: /\bHacim\b/gi, en: "Volume" },
    { tr: /\bDevir\b/gi, en: "RPM" },
    { tr: /\bAltın\b/gi, en: "Gold" },
    { tr: /\bGümüş\b/gi, en: "Silver" },
    { tr: /\bLevha\b/gi, en: "Plate / Sheet" },
    { tr: /\bSatır\b/gi, en: "Cleaver" },
    { tr: /\bÖnden\b/gi, en: "Front" },
    { tr: /\bKalın\b/gi, en: "Thick" },
    { tr: /\bDüşük\b/gi, en: "Low" },
    { tr: /\bKüçük\b/gi, en: "Small" },
    { tr: /\bBüyük\b/gi, en: "Large" },
    { tr: /\bDerin\b/gi, en: "Deep" },
    { tr: /\bOcak\b/gi, en: "Cooktop / Burner" },
    { tr: /\bEvye\b/gi, en: "Sink" },
    { tr: /\bBüfe\b/gi, en: "Buffet" },
    { tr: /\bKase\b/gi, en: "Bowl" },
    { tr: /\bMaşa\b/gi, en: "Tong" },
    { tr: /\bHuni\b/gi, en: "Funnel" },
    { tr: /\bTava\b/gi, en: "Pan" },
    { tr: /\bŞişe\b/gi, en: "Bottle" },
    { tr: /\bSacı\b/gi, en: "Sheet / Griddle Pan" },
    { tr: /\bMavi\b/gi, en: "Blue" },
    { tr: /\bSarı\b/gi, en: "Yellow" },
    { tr: /\bMeşe\b/gi, en: "Oak" },
    { tr: /\bAçık\b/gi, en: "Open" },
    { tr: /\bSeri\b/gi, en: "Series" },
    { tr: /\bTipi\b/gi, en: "Type" },
    { tr: /\bAdet\b/gi, en: "Pcs" },
    { tr: /\bSeti\b/gi, en: "Set" },
    { tr: /\bKapı\b/gi, en: "Door" },
    { tr: /\bKöşe\b/gi, en: "Corner" },
    { tr: /\bAyrı\b/gi, en: "Separate" },
    { tr: /\bİnce\b/gi, en: "Thin" },
    { tr: /\bOrta\b/gi, en: "Medium" },
    { tr: /\bLüks\b/gi, en: "Luxury" },
    { tr: /\bÖzel\b/gi, en: "Special / Custom" },
    { tr: /\bYeni\b/gi, en: "New" },
    { tr: /\bOtel\b/gi, en: "Hotel" },
    { tr: /\bNotr\b/gi, en: "Neutral" },
    { tr: /\bNötr\b/gi, en: "Neutral" },
    { tr: /\bİçin\b/gi, en: "for" },
    { tr: /\bÇay\b/gi, en: "Tea" },
    { tr: /\bSac\b/gi, en: "Sheet / Griddle Pan" },
    { tr: /\bCam\b/gi, en: "Glass" },
    { tr: /\bGri\b/gi, en: "Grey" },
    { tr: /\bTip\b/gi, en: "Type" },
    { tr: /\bSet\b/gi, en: "Set" },
    { tr: /\bBoy\b/gi, en: "Length" },
    { tr: /\bÇap\b/gi, en: "Diameter" },
    { tr: /\bGüç\b/gi, en: "Power" },
    { tr: /\bHız\b/gi, en: "Speed" },
    { tr: /\bGül\b/gi, en: "Rose" },
    { tr: /\bSığ\b/gi, en: "Shallow" },
    { tr: /\bDüz\b/gi, en: "Flat" },
    { tr: /\bEko\b/gi, en: "Eco" },
    { tr: /\bİle\b/gi, en: "with" },
    { tr: /\bEn\b/gi, en: "Width" },
    { tr: /\bVe\b/gi, en: "&" },
];

export function translateProductName(name) {
  if (!name) return "";
  let translated = name;
  for (const m of mappings) {
    translated = translated.replace(m.tr, m.en);
  }
  return translated.replace(/\s+/g, ' ').trim();
}

export function getProductName(product, lang) {
  if (!product) return "";
  if (lang === "tr") return product.name_tr || product.name_en || "";
  const name = product.name_en || product.name_tr || "";
  return translateProductName(name);
}

export function translateSubcategoryName(subcat, lang) {
  if (!subcat) return "";
  if (lang === "tr") return subcat;
  return translateProductName(subcat);
}

export function translateSeriesName(series, lang) {
  if (!series) return "";
  if (lang === "tr") return series;
  return translateProductName(series);
}

export function translateSpecKey(key, lang) {
  if (!key) return "";
  if (lang === "tr") return key;
  
  const keyMap = {
    "malzeme": "Material",
    "yüzey işlemesi": "Surface Treatment",
    "yüzey isleme": "Surface Treatment",
    "kullanım alanı": "Area of Use",
    "kullanim alani": "Area of Use",
    "garanti": "Warranty",
    "model": "Model",
    "kapasite": "Capacity",
    "güç": "Power",
    "guc": "Power",
    "voltaj": "Voltage",
    "ebat": "Dimensions",
    "ebatlar": "Dimensions",
    "ağırlık": "Weight",
    "agirlik": "Weight",
    "kontrol paneli": "Control Panel",
    "enerji sınıfı": "Energy Class",
    "enerji sinifi": "Energy Class",
    "seri": "Series",
    "renk": "Color",
    "hacim": "Volume",
    "gaz tüketimi": "Gas Consumption",
    "gaz tuketimi": "Gas Consumption",
    "su tüketimi": "Water Consumption",
    "su tuketimi": "Water Consumption",
    "program sayısı": "Number of Programs",
    "program sayisi": "Number of Programs",
    "sepet ölçüsü": "Basket Size",
    "sepet olcusu": "Basket Size",
  };

  const normalized = key.toLowerCase().trim();
  return keyMap[normalized] || translateProductName(key);
}

export function translateSpecValue(value, lang) {
  if (!value) return "";
  if (lang === "tr") return value;
  
  const valMap = {
    "paslanmaz çelik": "Stainless Steel",
    "paslanmaz celik": "Stainless Steel",
    "satine": "Satin",
    "parlak": "Polished",
    "endüstriyel ve profesyonel mutfaklar": "Industrial and Professional Kitchens",
    "endustriyel ve profesyonel mutfaklar": "Industrial and Professional Kitchens",
    "profesyonel mutfaklar": "Professional Kitchens",
    "endüstriyel mutfaklar": "Industrial Kitchens",
    "2 yıl": "2 Years",
    "2 yil": "2 Years",
    "1 yıl": "1 Year",
    "1 yil": "1 Year",
    "gri": "Grey",
    "siyah": "Black",
    "kırmızı": "Red",
    "kirmizi": "Red",
    "beyaz": "White",
    "antrasit": "Anthracite",
    "ceviz": "Walnut",
    "evet": "Yes",
    "hayır": "No",
    "hayir": "No",
  };

  const normalized = value.toLowerCase().trim();
  if (valMap[normalized]) return valMap[normalized];
  return translateProductName(value);
}
